<!-- Toast Messages -->
<p-toast
  data-testid="logic-transfer-form-toast"
  position="top-right"
  [baseZIndex]="9999"
  [autoZIndex]="true"
  [showTransformOptions]="'translateX(100%)'"
  [hideTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'0.3s ease-in'"
  [hideTransitionOptions]="'0.3s ease-out'"
  [preventDuplicates]="true"
></p-toast>

<app-add-form
  data-testid="logic-transfer-form"
  [title]="config.title"
  [formFields]="updatedFormFields()"
  [headerActions]="updatedHeaderActions()"
  [tableSections]="updatedTableSections()"
  [editMode]="editMode"
  [viewMode]="viewMode"
  [initialData]="enrichedInitialData()"
  [loading]="loading()"
  [getFieldError]="getFieldError.bind(this)"
  (formAction)="onFormAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
  (tableAction)="onTableAction($event)"
>
  <!-- Actions Template for Product Details table -->
  <ng-template #actionsTemplate let-rowData>
    <div class="flex gap-2 justify-center">
      <span
        [attr.data-testid]="'logic-transfer-form-action-delete-' + rowData.id"
        (click)="onDeleteProduct(rowData)"
        class="action-link action-delete cursor-pointer"
      >
        {{ "common.actions.delete" | translate }}
      </span>
    </div>
  </ng-template>
</app-add-form>

<!-- Stock Selection Dialog -->
<app-stock-selection-dialog
  data-testid="logic-transfer-form-stock-selection-dialog"
  [(visible)]="showItemDialog"
  [warehouseCode]="dialogWarehouseCode()"
  [existingSkuCodes]="existingSkuCodes()"
  (confirm)="onStockDialogConfirm($event)"
  (visibleChange)="onItemDialogVisibleChange($event)"
></app-stock-selection-dialog>

<app-fefo-override-dialog
  [(visible)]="fefoOverrideVisible"
  [data]="fefoOverrideData"
  (result)="onFefoOverrideResult($event)"
></app-fefo-override-dialog>
